import React, { Component, PropTypes } from 'react';
import Day from './Day';
import { DayType } from './DayType';
import './../../../../styles/styles.scss';

class Month extends Component {
  render() {
    const {
      styling
    } = this.props;
    return (
        <div className="DayPicker-Month" role="grid">
          <div className="DayPicker-Caption">
            <div>March 2017</div>
          </div>
          <div className="DayPicker-WeekDays DayPicker-Weekdays" role="rowgroup">
            <div className="DayPicker-WeekDaysRow DayPicker-WeekdaysRow">
              <div className="DayPicker-WeekDay" title="Su" role="columnheader">
                <div>Su</div>
              </div>
              <div className="DayPicker-WeekDay" title="Mo" role="columnheader">
                <div>Mo</div>
              </div>
              <div className="DayPicker-WeekDay" title="Tu" role="columnheader">
                <div>Tu</div>
              </div>
              <div className="DayPicker-WeekDay" title="We" role="columnheader">
                <div>We</div>
              </div>
              <div className="DayPicker-WeekDay" title="Th" role="columnheader">
                <div>Th</div>
              </div>
              <div className="DayPicker-WeekDay" title="Fr" role="columnheader">
                <div>Fr</div>
              </div>
              <div className="DayPicker-WeekDay" title="Sa" role="columnheader">
                <div>Sa</div>
              </div>
            </div>
          </div>

          <div className="DayPicker-Body" role="rowgroup">

            <div className="DayPicker-Week" role="row">
              <Day type={DayType.Empty} styling={styling} />
              <Day type={DayType.Empty} styling={styling}/>
              <Day type={DayType.Empty} styling={styling}/>
              <Day day="1" type={DayType.UnavailablePrevious} styling={styling}/>
              <Day day="2" type={DayType.UnavailablePrevious} styling={styling}/>
              <Day day="3" type={DayType.UnavailablePrevious} styling={styling}/>
              <Day day="4" type={DayType.UnavailablePrevious} styling={styling}/>
            </div>

            <div className="DayPicker-Week" role="row">
              <Day day="5" price="$100" type={DayType.SelectedStart} styling={styling}/>
              <Day day="6" type={DayType.SelectedSpinner} styling={styling}/>
              <Day day="7" type={DayType.SelectedEnd} styling={styling}/>
              <Day day="8" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="9" type={DayType.UnavailableFuture} styling={styling}/>
              <Day day="10" type={DayType.UnavailableFuture} styling={styling}/>
              <Day day="11" price="$100" type={DayType.Available} styling={styling}/>
            </div>

            <div className="DayPicker-Week" role="row">
              <Day day="12" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="13" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="14" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="15" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="16" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="17" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="18" price="$100" type={DayType.Available} styling={styling}/>
            </div>

            <div className="DayPicker-Week" role="row">
              <Day day="19" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="20" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="21" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="22" price="$100" type={DayType.Available} styling={styling}/>
              <Day day="23" price="$100" type={DayType.NoCheckIn} styling={styling}/>
              <Day day="24" price="$100" type={DayType.NoCheckOut} styling={styling}/>
              <Day day="25" price="$100" type={DayType.Available} styling={styling}/>
            </div>

            <div className="DayPicker-Week" role="row">
              <Day day="26" price="$75" type={DayType.GroupCodeAvailable} styling={styling}/>
              <Day day="27" price="$75" type={DayType.GroupCodeAvailable} styling={styling}/>
              <Day day="28" price="$75" type={DayType.GroupCodeAvailable} styling={styling}/>
              <Day day="29" price="$75" type={DayType.GroupCodeAvailable} styling={styling}/>
              <Day day="30" price="$75" type={DayType.GroupCodeAvailable} styling={styling}/>
              <Day day="31" price="$75" type={DayType.GroupCodeAvailable} styling={styling}/>
              <Day type={DayType.Empty} />
            </div>

          </div>
        </div>
    );
  }
}

export default Month;


// WEBPACK FOOTER //
// ./src/components/pages/theme/calendar/Month.js